module.exports = require('./dist/animate-components.min.js');



//////////////////
// WEBPACK FOOTER
// ./~/animate-components/main.js
// module id = 72
// module chunks = 168707334958949